﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import VeilederUtlandDto from '../Models/VeilederUtlandDto';
import { valgReducer } from './Valg/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { satserReducer, universiteterReducer } from './Satser/Reducers';

const rootReducer = combineReducers<VeilederUtlandAppState>({
    valg: valgReducer,
    epiContext: (
        state: EpiContext<VeilederUtlandDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederUtlandDto>,
    ): EpiContext<VeilederUtlandDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
    resultat: resultatReducer,
    satser: satserReducer, 
    universiteter: universiteterReducer,
});

export type VeilederUtlandAppState = EpiAppStateMedSteg<VeilederUtlandDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: ReturnType<typeof satserReducer>; 
    universiteter: ReturnType<typeof universiteterReducer>;
};

export default function configureStore(): Store<VeilederUtlandAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}